import { library } from "@fortawesome/fontawesome-svg-core";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styles } from "@repo/helpers";
import { useMemo } from "react";

import style from "./style.module.scss";
import { Props } from "./types";

library.add(faSyncAlt);
export function Refresh(props: Props) {
	const { tag = "div", children, className, right, ...tagProps } = props;
	const tagClass = useMemo(() => `${style.refreshIcon} ${styles(className)}`, [className]);
	const HtmlTag = tag as any;
	return (
		<HtmlTag {...tagProps} className={tagClass}>
			{renderRefresh()}
			{children}
			{renderRefresh(true)}
		</HtmlTag>
	);

	function renderRefresh(isRight?: boolean) {
		if (right === isRight)
			return (
				<span className={className}>
					<FontAwesomeIcon icon={faSyncAlt} />
				</span>
			);
		return null;
	}
}
